/**
 * Listing Form Constants
 * 
 * Shared constants for cargo and jet listing forms.
 */

export const indianCities = [
  "Mumbai", "Delhi", "Bangalore", "Chennai", "Kolkata", "Hyderabad", 
  "Pune", "Ahmedabad", "Jaipur", "Surat", "Lucknow", "Kanpur",
  "Nagpur", "Indore", "Thane", "Bhopal", "Goa", "Chandigarh"
];

export const vehicleTypes = {
  road: ["Truck", "Container", "Mini Truck", "Trailer"],
  rail: ["Container Wagon", "Flat Wagon", "Box Wagon"],
  air: ["Cargo Plane", "Passenger Cargo"],
  water: ["Container Ship", "Bulk Carrier", "Tanker", "Barge"],
};

export const jetModels = [
  "Cessna Citation", "Gulfstream G650", "Bombardier Global", 
  "Dassault Falcon", "Embraer Phenom", "HondaJet Elite"
];

export const amenitiesList = [
  "WiFi", "Bar", "Catering", "Entertainment", "Bedroom", "Conference Room"
];

export const initialCargoForm = (user) => ({
  transport_mode: "road",
  origin_city: "",
  destination_city: "",
  departure_date: null,
  departure_time: "",
  available_capacity: "",
  price_per_kg: "",
  vehicle_type: "",
  description: "",
  contact_phone: user?.phone || "",
  contact_email: user?.email || "",
  space_length: "",
  space_width: "",
  space_height: "",
  max_weight: "",
  eta_hours: "",
});

export const initialJetForm = (user) => ({
  origin_city: "",
  destination_city: "",
  departure_date: null,
  departure_time: "",
  available_seats: "",
  price_per_seat: "",
  jet_model: "",
  description: "",
  contact_phone: user?.phone || "",
  contact_email: user?.email || "",
});
